import { PoetryService } from 'api/poetryClub/service';
import { useCallback } from 'react';


export const usePoetry = () => {
    const onGetAllPoetry = useCallback(async () => {
        try {
            const response = await PoetryService.getInstance().findAll();

            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, data: null };
        }
    }, []);

    const onGetOnePoetry = useCallback(async (id: number) => {
        try {
            const response = await PoetryService.getInstance().findOne(id);

            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, data: null };
        }
    }, []);

    const onGetPoetryClubInfo = useCallback(async () => {
        try {
            const response = await PoetryService.getInstance().findClubInfo();

            return { success: true, data: response.data };
        } catch (error) {
            return { success: false, data: null };
        }
    }, []);

    return { onGetAllPoetry, onGetOnePoetry, onGetPoetryClubInfo };
};
